import { render } from "./Recovery.vue?vue&type=template&id=5ab1e635&scoped=true&ts=true"
import script from "./Recovery.vue?vue&type=script&lang=ts"
export * from "./Recovery.vue?vue&type=script&lang=ts"

import "./Recovery.vue?vue&type=style&index=0&id=5ab1e635&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab1e635"]])

export default __exports__